import React from "react";
import ReactTable from "react-table";
import Spinner from "../../../../../../../utils/Spinner";

const ValidationMetrics = (props) => {
  const vddata = props.data;
  const fetching = props.fetching;

  return (
    <>
      {fetching ? (
        <div className="justify-content-md-center">
          {" "}
          <Spinner />
        </div>
      ) : (
        <ReactTable
          data={vddata}
          sortable={true}
          size="sm"
          showPagination={true}
          className="valid__m"
          columns={[
            {
              Header: () => (
                <div className="column__table__header">Metric Key</div>
              ),
              accessor: "metricKey",
            },
            {
              Header: () => (
                <div className="column__table__header">Metric Value</div>
              ),
              accessor: "metricValue",
            },
          ]}
          defaultPageSize={5}
        />
      )}
    </>
  );
};

export default ValidationMetrics;
